import React, { createContext, useContext, useState, useCallback } from 'react';

const TENANT_STORAGE_KEY = 'tenant';

const TenantContext = createContext();

export const useTenant = () => {
  const context = useContext(TenantContext);
  if (!context) {
    throw new Error('useTenant must be used within TenantProvider');
  }
  return context;
};

const getStoredTenant = () => {
  try {
    const stored = localStorage.getItem(TENANT_STORAGE_KEY);
    return stored ? JSON.parse(stored) : null;
  } catch (error) {
    console.error('Failed to parse tenant from storage:', error);
    return null;
  }
};

const storeTenant = (tenant) => {
  if (tenant) {
    localStorage.setItem(TENANT_STORAGE_KEY, JSON.stringify(tenant));
  } else {
    localStorage.removeItem(TENANT_STORAGE_KEY);
  }
};

export const TenantProvider = ({ children }) => {
  const [tenant, setTenantState] = useState(getStoredTenant);

  const setTenant = useCallback((tenantData) => {
    setTenantState(tenantData);
    storeTenant(tenantData);
  }, []);

  const clearTenant = useCallback(() => {
    setTenantState(null);
    storeTenant(null);
  }, []);

  const value = {
    tenant,
    setTenant,
    clearTenant,
    tenantSlug: tenant?.slug ?? null,
    theme: tenant?.theme ?? {},
    permissions: tenant?.permissions ?? [],
  };

  return (
    <TenantContext.Provider value={value}>
      {children}
    </TenantContext.Provider>
  );
};
